import CropFreeIcon from '@mui/icons-material/CropFree';
import NfcIcon from '@mui/icons-material/Nfc';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { useHomeData } from '../LoadHomeData/HomeDataProvider';

export const HeaderScanButtons = () => {
    const { homepageData } = useHomeData();
    const isGuard = homepageData?.authorizations?.mayUseGuardsMobileFx ?? false;
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const inNfcEmulation = pathname.includes('/functions/cern-access');
    const inAccessEmulation = pathname.includes('/functions/access-emulation');
    const inTemporaryBadge = pathname.includes('/functions/temporary-badge');

    const resetCamera = (event: any) => {
        if (inTemporaryBadge) {
            event.preventDefault();
            navigate('/scan');
        }
    };

    const resetNFC = (event: any) => {
        if (inAccessEmulation) {
            event.preventDefault();
            navigate('/functions/access-emulation'); //trick to reload component's state
        } else if (inNfcEmulation) {
            event.preventDefault();
            navigate('/functions/cern-access');
        }
    };

    return (
        <Box
            style={{
                flex: 'auto',
                display: 'flex',
                flexFlow: 'row-reverse',
            }}
        >
            <IconButton
                id="scanQR"
                size="large"
                // edge="start"
                color="inherit"
                aria-label="scan"
                to="/scan"
                component={Link}
                onClick={resetCamera}
            >
                <CropFreeIcon />
            </IconButton>
            {isGuard && (
                <IconButton
                    id="nfcIcon"
                    size="large"
                    edge="start"
                    color="inherit"
                    aria-label="scanNFC"
                    to="/functions/cern-access"
                    component={Link}
                    onClick={resetNFC}
                >
                    <NfcIcon />
                </IconButton>
            )}
        </Box>
    );
};
